module.exports = __webpack_public_path__ + "img/twitter-dark.82e201eb.svg";